import { Box, Checkbox, Chip, FormControl, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import NoRecordsDownload from '../../../../../../asset/svg/NoDownloads.svg'
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/DownloadQR/downloadQR.scss'
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/DownloadQR/DownloadQRModal/downloadQRModal.scss';
import { ASSETS_REGISTER_PATH } from '../../../../../../utils/Constants';
import SearchIcon from '@mui/icons-material/Search';
import { Stack } from '@mui/system';
import { GET_ISSUED_STORE_DOWNLOAD_QR, GET_OR_CODE_ISSUED_STORE, HIDE_MODAL_SELECT_STORE, SHOW_MODAL_ASSETGROUP } from '../../../../../../sagas/type';
import { useDispatch, useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import { useSnackbar } from 'notistack';
import CustomMessage from '../../../../../../components/common/Snackbar/Snackbar';
import { getLocalStoreString } from '../../../../../../utils/Helper';
import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

function DownloadQR() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { IssuedStoreDataDownloadQr, SelectedStoreDatas } = useSelector(mapStateToProps);
    const storeNaemGet = getLocalStoreString("storeName");
    const [searchName, setSearchName] = useState('');
    const [issedQRCodeData, setIssuedQRCodeData] = useState([])
    const [selectedItemData, setSelectedItemData] = useState([])
    const [disableBtn, setDisableBtn] = useState(true)
    const [isDownloadQRMoadl, setIsDownloadQRMoadl] = useState(false)
    const [imageData, setImageData] = useState();
    const [pdfData, setPdfData] = useState()
    const [numPagess, setNumPages] = useState(1);
    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }
    const handleBack = () => {
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
    }
    const handleBackModal = () => {
        setIsDownloadQRMoadl(false)
    }
    useEffect(() => {
        setIssuedQRCodeData(IssuedStoreDataDownloadQr)
    }, [selectedItemData, issedQRCodeData])

    useEffect(() => {
        const code = SelectedStoreDatas && SelectedStoreDatas.length && SelectedStoreDatas[0]?.code;
        dispatch({
            type: GET_ISSUED_STORE_DOWNLOAD_QR,
            payload: { storeCode: code },
        })
    }, [])

    const handleCheckBoxChange = (id) => {
        if (selectedItemData.includes(id)) {
            setSelectedItemData(selectedItemData?.filter(item => item !== id))
        } else {
            setSelectedItemData([...selectedItemData, id])
        }
    };
    const handleSelectAll = () => {

        if (selectedItemData?.length === IssuedStoreDataDownloadQr?.length) {
            setSelectedItemData([]);
        } else {
            setSelectedItemData(IssuedStoreDataDownloadQr?.map(item => item?.id))
        }
    }

    const handleDownloadQR = () => {
        const assetCode = IssuedStoreDataDownloadQr?.filter((item) => selectedItemData.includes(item?.id)).map(item => item?.code)
        const codeStore = SelectedStoreDatas && SelectedStoreDatas?.length && SelectedStoreDatas[0]?.code
        dispatch({
            type: GET_OR_CODE_ISSUED_STORE,
            payload: { storeCode: codeStore, assetCode: assetCode },
            handleCheck: handleCheck,
            enqueueSnackbar: enqueueSnackbar,
        })
    }
    //.............Download QR.................
    const handleCheck = (issuedQRCode) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const imgSize = 200;
        const fontSize = 18;
        const margin = 10;
        const borderSize = 20;
        const imagesPerRow = 4;
        const rowsPerPage = 5;
        canvas.width = imagesPerRow * (imgSize + 2 * borderSize + margin) + margin;
        canvas.height = rowsPerPage * (imgSize + 3 * borderSize + margin) + margin;

        const doc = new jsPDF("p", "mm", "a4");

        let x = margin;
        let y = margin + 40;
        let pageImages = 0;

        issuedQRCode?.forEach(async (asset, index) => {
            const img = new Image();
            img.onload = () => {
                ctx.fillStyle = "white";
                ctx.fillRect(x, y, imgSize + 2 * borderSize, imgSize + 2 * borderSize);
                ctx.drawImage(img, x + borderSize, y, imgSize, imgSize);
                ctx.font = `${fontSize}px Arial`;
                ctx.textAlign = "center";
                ctx.fillStyle = "black";
                ctx.fillText(
                    `${asset?.assetCode} - ${asset?.name}`,
                    x + borderSize + imgSize / 2,
                    y + borderSize + imgSize + fontSize - 39
                );
                ctx.fillText(
                    `${SelectedStoreDatas[0]?.code} - ${SelectedStoreDatas[0]?.name}`,
                    x + borderSize + imgSize / 2,
                    y + borderSize + imgSize + fontSize - 18
                );

                x += imgSize + 2 * borderSize + margin;
                pageImages++;

                if (pageImages === imagesPerRow) {
                    x = margin;
                    y += imgSize + 2 * borderSize + margin;
                    pageImages = 0;
                }

                if ((index + 1) % (imagesPerRow * rowsPerPage) === 0 || index === issuedQRCode?.length - 1) {
                    doc.addImage(canvas, "PNG", 0, 0, 210, 297);
                    if (index !== issuedQRCode?.length - 1) {
                        doc.addPage();
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        y = margin;
                    }
                }

                if (index === issuedQRCode?.length - 1) {
                    setIsDownloadQRMoadl(true)
                    const pdfDataUri = doc.output('datauristring');
                    setImageData(pdfDataUri)
                }

            };
            img.src = `data:image/png;base64,${asset?.image}`;

        });

    };

    const navigatorShare = async (pdfBase64) => {
        const value = await fetch(imageData).then(response => response.blob())
        if (navigator.share) {
            const data = [new File([value], "QR.pdf", { type: "application/pdf" })]
            navigator.share({
                files: data,
            })
                .then(() => console.log("Shared successfully"))
                .catch(error => console.error("Not shared:", error))
        } else if (AssetManager) {
            AssetManager.shareFile(pdfBase64.split(',')[1], 'QR_Code');
        } else {
            console.log("QR_code not Found");
        }
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
    }

    const handleDownloadQRData = async () => {
        // Download PDF
        const value = await fetch(imageData).then(response => response.blob())
        if (imageData) {
            const blob = new Blob([value], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'QR_Code.pdf';
        }
        CustomMessage("QR downloaded successfully", 'success', enqueueSnackbar);
        // Share PDF            
        navigatorShare(imageData);
    }

    const onDocumentLoadSuccess = (e) => {
        const { numPages } = e._pdfInfo;
        setNumPages(numPages)
    }
    const renderFile = (imageData) => {
        return (
            <Document file={imageData} onLoadSuccess={(e) => onDocumentLoadSuccess(e)}>
                {Array.from(new Array(numPagess), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        )
    }

    return (
        <>
            <div className='Download-QR-Container'>
                <div className='Download-QR-Container_header'>
                    <div className='Download-QR-Container_head-height'>
                        <img className='Download-QR-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='Download-QR-Container_header_content'>Download QR</span>
                    </div>
                    <div>
                        {SelectedStoreDatas && SelectedStoreDatas?.length && <Stack direction="row" spacing={1} sx={{ width: "fit-content", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%" }} className='Download-QR-Container_Stock-chip'>
                            <Chip label={SelectedStoreDatas && SelectedStoreDatas?.length && SelectedStoreDatas[0]?.name} className='Download-QR-Container_Store-chip' sx={{ color: "#12B9DD", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                    </div>

                </div>
                <div className='Download-QR-Container_searchcontainer'>
                    <FormControl sx={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                        <TextField size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                            InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                    </FormControl>
                </div>
                {IssuedStoreDataDownloadQr?.length > 0 &&
                    <div className='Download-QR-Container_Select-All'>
                        <Typography sx={{ color: "#8074FF", fontSize: "14px", fontWeight: 700 }} onClick={handleSelectAll}>Select All</Typography>
                    </div>
                }
                <div className='Download-QR-Container_Data-container'>

                    {IssuedStoreDataDownloadQr?.length > 0 ? (IssuedStoreDataDownloadQr?.filter((element) => element?.name?.toLowerCase().includes(searchName?.toLowerCase()))?.map(obj => { return { ...obj, date: new Date(obj?.issuedAt) } })
                        .sort((a, b) => b?.date - a?.date).map((selectData, index) => {
                            return (
                                <Box key={selectData?.id} sx={{ marginBottom: '10px' }}>
                                    <Box className='Download-QR-Container_Data'>
                                        <div className='Download-QR-Container_Data_Child'>
                                            <div key={index}>
                                                <Checkbox onChange={() => handleCheckBoxChange(selectData?.id)} checked={selectedItemData?.includes(selectData?.id)} {...label} color="primary" sx={{
                                                    color: "#fff",
                                                    '&.Mui-checked': {
                                                        color: "#8074FF",
                                                        opacity: "1"
                                                    },
                                                    opacity: "0.3"
                                                }} />
                                            </div>
                                            <div style={{ width: "100%", padding: "0.6rem" }}>
                                                <div className='Download-QR-Container_card-Parent-Container' style={{ position: "relative" }}>
                                                    <div className="Download-QR-Container_card-Heading">
                                                        <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontWeight: 400, fontSize: '12px', textTransform: 'capitalize', paddingBottom: "5px" }} value="name">{selectData?.code}</Typography>
                                                        <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px' }}>{selectData?.type} - {selectData?.name}</Typography>
                                                    </div>
                                                </div>
                                                <div>
                                                    <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px', lineHeight: '16px', textTransform: 'capitalize' }}>{selectData?.description}</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                    <Box className='Download-QR-Container_DateCard'>
                                        {selectData?.issuedAtDate && <div className='Download-QR-Container_DateCard_Child'>
                                            <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "3px 8px" }}>Registered : {moment(selectData?.issuedAtDate).format('DD MMM YYYY')}</Typography>
                                        </div>}
                                        {selectData?.effectiveDate && <div className='Download-QR-Container_DateCard_Child'>
                                            <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "3px 8px" }}>Effective : {moment(selectData?.effectiveDate).format('DD MMM YYYY')}</Typography>
                                        </div>}
                                    </Box>
                                </Box>

                            )
                        })) :
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                            <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                                <img style={{ heigth: '54px', width: '68px' }} src={NoRecordsDownload} alt="" />
                            </div>
                            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                                <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No QR Found</Typography>
                            </div>
                        </div>
                    }


                </div>
                <div className='Download-QR-Container_okbutton-container'>
                    <button disabled={selectedItemData.length === 0} className='Download-QR-Container_active-button' style={{ whiteSpace: "nowrap" }} onClick={handleDownloadQR}>Download</button>
                </div>
            </div>
            {isDownloadQRMoadl && (
                <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                    <div className='Download-Agreement-Modal-Container'>
                        <div className='Download-Agreement-Modal-Container_header'>
                            <div>
                                <img className='Download-Agreement-Modal-Container_header_image' src={LeftArrow} alt="" onClick={handleBackModal} />&nbsp;&nbsp;
                                <span className='Download-Agreement-Modal-Container_header_content'>Download QR</span>
                            </div>
                        </div>
                        <div className='Download-Agreement-Modal-Container_Document-image'>
                            <div id='pdfcontainer' className='Download-Agreement-Modal-Container_Document-image_child'>
                                {renderFile(imageData)}
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
                            <div className='Download-Agreement-Modal-Container_btn-bottom'>
                                <div className='Download-Agreement-Modal-Container_okbutton-container'>
                                    <button id='downloadBtn' className='Download-Agreement-Modal-Container_active-button' onClick={handleDownloadQRData} style={{ whiteSpace: "nowrap" }} >Download</button>
                                </div>
                            </div>
                        </div>
                    </div >
                </div>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        IssuedStoreDataDownloadQr: state?.attendanceConfig?.IssuedStoreDataDownloadQr,
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
    }
}

export default DownloadQR;